import { createUseStyles } from '@glu/theming';

const styles = ({
  palette: {
    primary: { normal }
  },
  spacing: { unit }
}) => ({
  modalComponent: {},
  root: {
    visibility: 'hidden',
    position: 'fixed',
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1205,
    backgroundColor: '#fff',
    minHeight: '100%'
  },

  backdrop: {
    backgroundColor: '#fff',
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: 0
  },

  header: {
    border: '0',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  title: {
    textTransform: 'uppercase'
  },

  content: {
    backgroundClip: 'border-box',
    position: 'relative',
    display: 'flex',
    alignContent: 'center',
    flexDirection: 'column',
    paddingTop: 9.5 * unit
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  close: {
    background: 'transparent',
    opacity: 1,
    cursor: 'pointer',
    position: 'absolute',
    margin: 0,
    padding: 0,
    right: '20px',
    zIndex: 1,
    top: '20px',
    '&:active': {
      boxShadow: 'none'
    },
    '& svg': {
      fill: normal
    }
  },
  icon: {
    '& svg': {
      width: '75px',
      height: '75px',
      fill: normal
    }
  },

  modalIn: {
    transition: 'none',
    pointerEvents: 'auto',
    overflowX: 'hidden',
    overflowY: 'auto',
    visibility: 'visible',
    display: 'block'
  }
});

export default createUseStyles(styles);
